<template>
  <div class="page_eleModelManage">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
      </div>
    </div>
    <div class=" main-con p_divide_box">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/eleSigning' }">电子签约</el-breadcrumb-item>
          <el-breadcrumb-item>批量导入模板管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="uploadModel">上传模板</el-button>
        </div>
        <el-table v-loading="loading" class="doc_table" :data="tableData" style="width:100%">
          <el-table-column align="center" prop="sort" label="序号">
          </el-table-column>
          <el-table-column align="center" label="名称" prop="name" min-width="110px">
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="{row}">
              <div class="eleTabBtn">
                <el-button type="text" @click="uploadRowModel(row)" v-preventReClick>上传模板</el-button>
                <el-button type="text" @click="downModel(row)" v-preventReClick>下载模板</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog title="导入模板" :visible.sync="impVisible" width="500px">
      <el-form :model="impForm" ref="impForm" label-width="80px">
        <el-form-item label="模板名称" size="small">
          <el-input v-model="impForm.name" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="导入模板:" prop="code">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入模板</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="confirmImport" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "./../../common";
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        //下拉筛选
        showDropScreen: -1,
        listQuery: {
          parentId: 233
        },
        impVisible: false,
        isBtnLoading: false,
        impForm: {
          userid: '',
          parentId: null,
          id: '',
          name: '',
          isDeleted: '',
          code: '',
          sort: 0,
          remark: ''
        },
        fileList: [],
        rules: {
          code: {
            required: true,
            message: '请上传模板',
            trigger: 'blur'
          },
          name: {
            required: true,
            message: '请输入模板名称',
            trigger: 'blur'
          },
        },
      }
    },
    created() {
      this.getList()
    },
    methods: {
      // 获取列表
      getList() {
        this.loading = true;
        xz.AdvanceFun(this.listQuery, 'GetDicempUerList').then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.tableData = res.data;
          } else {
            this.loading = false;
            this.tableData = [];
          }

        })
      },
      uploadModel() {
        this.isBtnLoading = false;
        this.impForm = {
          userid: Cookies.get("userid-b"),
          parentId: 233,
          id: '',
          name: '',
          code: '',
          sort: this.tableData.length + 1,
          remark: ''
        }
        this.fileList = [];
        this.impVisible = true;
      },
      uploadRowModel(row) {
        this.isBtnLoading = false;
        this.impForm = {
          userid: Cookies.get("userid-b"),
          parentId: 233,
          id: row.id,
          name: row.name,
          code: row.code,
          sort: row.sort,
          remark: row.remark
        }
        this.fileList = [];
        this.impVisible = true;
      },
      // 上传结算单附件
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", '');
        formData.append("entid", '');
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.impForm.code = res;
          } else {
            this.impForm.code = '';
          }
        });
      },
      handleExceed() {
        this.$message.warning(`当前限制最多导入 1 个文件`);
      },
      // 删除结算单附件
      handleFileRemove() {
        this.impForm.code = '';
      },
      confirmImport() {
        this.$refs.impForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.AdvanceFun(this.impForm, 'AddUpdataDicempUerVal').then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.impVisible = false;
                this.isBtnLoading = false;
                this.$message.success('保存成功！');
              } else {
                this.getList();
                this.isBtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      downModel(row) {
        var path = this.$store.state.EMP.tablePath + row.code;
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.setAttribute('download', row.name + '.xls');
        aTag.click();
      },
    }
  }
</script>


<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }
</style>
<style>
  .page_eleModelManage .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_eleModelManage .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_eleModelManage .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_eleModelManage .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_eleModelManage .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_eleModelManage .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>